import React from 'react';

interface IMCSNotificationProps {
    id: string;
    overviewLandingPageUrl: string;
}

interface IMCSNotification {
    notificationId: string;
    subject: string;
    body: string;
    publishDate: string;
    publishDateUnformatted: Date;
}

interface State {
    notification: IMCSNotification | null;
    isLoading: boolean;
    error: string | null;
}

export class MCSNotification extends React.Component<IMCSNotificationProps, State> {
    private _isComponentMounted = false;

    constructor(props: IMCSNotificationProps) {
        super(props);
        this.state = {
            notification: null,
            isLoading: true,
            error: null
        };
    }

    public componentDidMount() {
        this._isComponentMounted = true;
        this.loadNotification();
    }

    public componentWillUnmount() {
        this._isComponentMounted = false;
    }

    public componentDidUpdate(prevProps: IMCSNotificationProps) {
        if (prevProps.id !== this.props.id) {
            this.loadNotification();
        }
    }

    private loadNotification() {
        const { id } = this.props;

        if (!id) {
            this.setState({ isLoading: false, error: 'No notification ID provided' });
            return;
        }

        this.setState({ isLoading: true, error: null });

        $.getJSON(`/api/topicnotifications/GetTopicNotification?id=${encodeURIComponent(id)}`)
            .done((notification: IMCSNotification) => {
                if (this._isComponentMounted) {
                    this.setState({
                        notification,
                        isLoading: false
                    });
                }
            })
            .fail((xhr, status, error) => {
                if (this._isComponentMounted) {
                    console.error('Failed to load notification:', error);
                    this.setState({
                        isLoading: false,
                        error: 'Failed to load notification'
                    });
                }
            });
    }

    public render() {
        const { notification, isLoading, error } = this.state;
        const { overviewLandingPageUrl } = this.props;

        if (isLoading) {
            return (
                <div className="row">
                    <div className="col-12 margin-top-25 text-center">
                        <i className="fa fa-spinner fa-spin fa-2x" aria-hidden="true"></i>
                        <span className="sr-only">Loading notification...</span>
                    </div>
                </div>
            );
        }

        if (error || !notification) {
            return (
                <div className="row">
                    <div className="col-12 margin-top-25">
                        <div className="alert alert-warning" role="alert">
                            {error || 'Notification not found'}
                            {overviewLandingPageUrl && (
                                <a href={overviewLandingPageUrl} className="alert-link margin-left-10">
                                    Return to notifications
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="row">
                <div className="col-12 margin-top-25">
                    <h1 className="hero blue">Notification</h1>
                    <div className="notificationSubjectRow align-items-lg-center">
                        <h2 className="margin-btm-0 hero blue d-lg-inline">{notification.subject}</h2>
                        <span className="notificationDate">
                            <span className="margin-left-15 margin-right-3 d-none d-lg-block"></span>
                            <i>{notification.publishDate}</i>
                        </span>
                    </div>
                    <div
                        className="notificationText margin-top-15"
                        dangerouslySetInnerHTML={{ __html: notification.body }}
                    />
                </div>
            </div>
        );
    }
}
